"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMetadataCreateRequestDTO = exports.AppMetadaOverwriteResponse = exports.AppMetadataOS = void 0;
var AppMetadataOS;
(function (AppMetadataOS) {
    AppMetadataOS["IOS"] = "ios";
    AppMetadataOS["ANDROID"] = "android";
})(AppMetadataOS || (exports.AppMetadataOS = AppMetadataOS = {}));
class AppMetadaOverwriteResponse {
    constructor(status, message, matchingApps, existingApps, existingPublisherCampaigns, appMetadataToCreate) {
        this.status = status;
        this.message = message;
        this.matchingApps = matchingApps;
        this.existingApps = existingApps;
        this.existingPublisherCampaigns = existingPublisherCampaigns;
        this.appMetadataToCreate = appMetadataToCreate;
    }
}
exports.AppMetadaOverwriteResponse = AppMetadaOverwriteResponse;
class AppMetadataCreateRequestDTO {
    constructor(active, advisories, app_id, app_view_url, apple_watch_enabled, bundle_id, canonical_country, categories, content_rating, createdAt, lastUpdated, description, eula_url, feature_graphic, filtered_name, global_rating_count, humanized_name, humanized_worldwide_last_month_downloads, humanized_worldwide_last_month_revenue, icon_url, imessage_enabled, imessage_icon, in_app_purchases, isMattersApp, name, os, permissions, price, privacy_policy_url, promo_text, publisher_address, publisher_country, publisher_email, publisher_id, publisher_name, rating, rating_count, rating_count_for_current_version, rating_for_current_version, release_date, screenshot_urls, short_description, subtitle, support_url, tablet_screenshot_urls, top_countries, unified_app_id, updated_date, url, valid_countries, website_url, version) {
        this.active = active;
        this.advisories = advisories;
        this.app_id = app_id;
        this.app_view_url = app_view_url;
        this.apple_watch_enabled = apple_watch_enabled;
        this.bundle_id = bundle_id;
        this.canonical_country = canonical_country;
        this.categories = categories;
        this.content_rating = content_rating;
        this.createdAt = createdAt;
        this.lastUpdated = lastUpdated;
        this.description = description;
        this.eula_url = eula_url;
        this.feature_graphic = feature_graphic;
        this.filtered_name = filtered_name;
        this.global_rating_count = global_rating_count;
        this.humanized_name = humanized_name;
        this.humanized_worldwide_last_month_downloads = humanized_worldwide_last_month_downloads;
        this.humanized_worldwide_last_month_revenue = humanized_worldwide_last_month_revenue;
        this.icon_url = icon_url;
        this.imessage_enabled = imessage_enabled;
        this.imessage_icon = imessage_icon;
        this.in_app_purchases = in_app_purchases;
        this.isMattersApp = isMattersApp;
        this.name = name;
        this.os = os;
        this.permissions = permissions;
        this.price = price;
        this.privacy_policy_url = privacy_policy_url;
        this.promo_text = promo_text;
        this.publisher_address = publisher_address;
        this.publisher_country = publisher_country;
        this.publisher_email = publisher_email;
        this.publisher_id = publisher_id;
        this.publisher_name = publisher_name;
        this.rating = rating;
        this.rating_count = rating_count;
        this.rating_count_for_current_version = rating_count_for_current_version;
        this.rating_for_current_version = rating_for_current_version;
        this.release_date = release_date;
        this.screenshot_urls = screenshot_urls;
        this.short_description = short_description;
        this.subtitle = subtitle;
        this.support_url = support_url;
        this.tablet_screenshot_urls = tablet_screenshot_urls;
        this.top_countries = top_countries;
        this.unified_app_id = unified_app_id;
        this.updated_date = updated_date;
        this.url = url;
        this.valid_countries = valid_countries;
        this.website_url = website_url;
        this.version = version;
    }
}
exports.AppMetadataCreateRequestDTO = AppMetadataCreateRequestDTO;
